// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_ImportInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subaccounts/anticipations/import/{subaccount_id}
 *
 * Triggers an import from the upstream provider. No body required —
 * subaccount_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface SubaccountsAnticipations_ImportInput {}

registerContract('SubaccountsAnticipations_ImportInput', {})
